import type { FeatureFlagProviderKind } from '@risksmart-app/feature-flags/src/provider-kind';

/**
 * Which OpenFeature provider `initialiseWebFeatureFlags` registered at boot,
 * or `null` when registration never happened (misconfigured build — flags
 * serve registry defaults — or any test tree, which never boots the app).
 *
 * Deliberately a LEAF module: it imports nothing but a type, so a consumer that
 * only needs to know whether a provider exists — `useAreFeatureFlagsReady`, and
 * therefore the ~440 modules that transitively reach the flag hooks — does not
 * pull `openfeature.ts` and, through it, the Datadog and flagd provider SDKs
 * into its module graph. Runtime bundles are unaffected either way (the app
 * boots `openfeature.ts` regardless); this keeps jsdom test graphs light.
 */
let activeProviderKind: FeatureFlagProviderKind | null = null;

export const getActiveFeatureFlagProviderKind =
  (): FeatureFlagProviderKind | null => activeProviderKind;

/** Set once by `initialiseWebFeatureFlags`; not part of the public surface. */
export const setActiveFeatureFlagProviderKind = (
  kind: FeatureFlagProviderKind
): void => {
  activeProviderKind = kind;
};
